import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';
import UsersAdmin from './UsersAdmin';
import UserDetailAdmin from './UserDetailAdmin';
import PricingAdmin from './PricingAdmin';
import CurrenciesAdmin from './CurrenciesAdmin';
import SettingsAdmin from './SettingsAdmin';
import AuditLogAdmin from './AuditLogAdmin';
import RegionsAdmin from './RegionsAdmin';
import QuoteOptionsAdmin from './QuoteOptionsAdmin';
import ServiceDescriptionAdmin from './ServiceDescriptionAdmin';
import PricingGuide from './PricingGuide';
import FxRatesAdmin from './FxRatesAdmin';

export default function AdminPage() {
  const { isAdmin, isManager, user } = useAuth();
  const isSales = user?.role === 'SALES';

  const PSM_ALLOWED = ['/admin/service-description', '/admin/pricing-guide'];
  const currentPath = window.location.pathname;
  const psmAllowed = isSales && PSM_ALLOWED.some(p => currentPath.startsWith(p));

  if (!isAdmin && !isManager && !psmAllowed) {
    return (
      <div className="flex h-60 items-center justify-center">
        <div className="text-center">
          <Shield size={32} className="mx-auto mb-3" style={{ color: 'hsl(var(--danger))' }} />
          <h3 className="font-semibold">Access Denied</h3>
          <p className="text-sm mt-1" style={{ color: 'hsl(var(--muted-fg))' }}>You don&apos;t have permission to access this area.</p>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="admin-page">
      <Routes>
        <Route path="/" element={<Navigate to={isAdmin ? '/admin/users' : '/admin/audit'} replace />} />
        <Route path="/users"      element={<UsersAdmin />} />
        <Route path="/users/:id"  element={<UserDetailAdmin />} />
        <Route path="/pricing"    element={<PricingAdmin />} />
        <Route path="/currencies" element={<CurrenciesAdmin />} />
        <Route path="/regions"       element={<RegionsAdmin />} />
        <Route path="/quote-options"       element={<QuoteOptionsAdmin />} />
        <Route path="/service-description" element={<ServiceDescriptionAdmin />} />
        <Route path="/pricing-guide"       element={<PricingGuide />} />
        <Route path="/settings"   element={<SettingsAdmin />} />
        <Route path="/audit"      element={<AuditLogAdmin />} />
        <Route path="/fx-rates"   element={<FxRatesAdmin />} />
      </Routes>
    </div>
  );
}
